export default "__VITE_ASSET__KnyLj6nr__"